import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from "@chakra-ui/react";
import { useState } from "react";
import { formatUnits } from "viem";
import { getChainById, getTokenByChainIdAndAddress, stringToBlobUrl } from "common";
import { RoundAccordionPanel } from "./RoundAccordionPanel";
import { RoundAccordionTitle } from "./RoundAccordionTitle";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundAccordion(_ref) {
  let {
    contributions
  } = _ref;
  const [defaultIndex, setDefaultIndex] = useState(undefined);
  const sortedContributions = contributions.sort((a, b) => b.amountInUsd - a.amountInUsd // Sort by amountInUsd in descending order
  );
  const firstContribution = sortedContributions[0];
  const chainId = firstContribution.chainId;
  const chain = getChainById(chainId);
  const chainLogo = stringToBlobUrl(chain.icon);
  const roundId = firstContribution.roundId;
  const roundName = firstContribution.round.roundMetadata.name;
  const lastUpdated = firstContribution.timestamp;
  let formattedAmount = "N/A";
  let totalContributionAmountInUsd = 0;
  let totalContributionInMatchingToken = 0;

  // Get the total contribution amount in USD and matching token
  // Get the formatted amount & token name
  sortedContributions.map(contribution => {
    totalContributionAmountInUsd += contribution.amountInUsd;
    totalContributionInMatchingToken += Number(contribution.amount);
    const token = getTokenByChainIdAndAddress(contribution.chainId, contribution.tokenAddress);
    if (token) {
      formattedAmount = `${formatUnits(BigInt(totalContributionInMatchingToken), token.decimals)} ${token.code}`;
    }
  });
  return /*#__PURE__*/_jsx(Accordion, {
    className: "w-full",
    allowMultiple: true,
    defaultIndex: defaultIndex,
    onChange: index => {
      setDefaultIndex(index);
    },
    children: /*#__PURE__*/_jsxs(AccordionItem, {
      isDisabled: sortedContributions.length === 0,
      children: [/*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsxs(AccordionButton, {
          _expanded: {
            bg: "white",
            color: "black"
          },
          _hover: {
            bg: "white",
            color: "black"
          },
          _disabled: {
            bg: "white",
            color: "black"
          },
          children: [/*#__PURE__*/_jsx(RoundAccordionTitle, {
            chainLogo,
            roundName,
            chainId,
            roundId,
            lastUpdated,
            formattedAmount,
            totalContributionAmountInUsd
          }), /*#__PURE__*/_jsx(AccordionIcon, {})]
        })
      }), /*#__PURE__*/_jsx(AccordionPanel, {
        pb: 0,
        px: 0,
        children: /*#__PURE__*/_jsx(RoundAccordionPanel, {
          contributions: sortedContributions
        })
      })]
    })
  });
}